import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';
import config from '@plone/volto/registry';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

import styles from './styles.module.css';
import type { QubicaViewProps } from '../Common/utils';

const ContactView = ({ content }: QubicaViewProps) => {
  const intl = useIntl();
  const Container = config.getComponent('Container').component || 'div';
  const Image = config.getComponent('Image').component;

  return (
    <Container>
      <div className={styles.documentHeadingContainer}>
        {content.image && (
          <div className={styles.imageContainer}>
            <Image
              item={content}
              alt={content.image_caption ?? ''}
              loading="lazy"
              className={styles.image}
            />
          </div>
        )}
        <div className={styles.documentHeading}>
          {content.title && (
            <h1 className={cx('documentFirstHeading', styles.title)}>
              {content.title}
            </h1>
          )}
          {content.description && (
            <div className={styles.intro}>{content.description}</div>
          )}
          {content.jobtitle && (
            <div className={cx(styles.intro, styles.jobtitle)}>
              {content.jobtitle.title}
            </div>
          )}

          {content.reference && (
            <div className={styles.intro}>{content.reference}</div>
          )}
        </div>
      </div>

      <div className={styles.addressTable}>
        {content.address && (
          <div className={styles.row}>
            <div className={styles.headingCell}>
              {intl.formatMessage(messages.address_label)}
            </div>
            <div className={styles.cell}>{content.address}</div>
          </div>
        )}
        {content.city && (
          <div className={styles.row}>
            <div className={styles.headingCell}>
              {intl.formatMessage(messages.city_label)}
            </div>
            <div className={styles.cell}>{content.city}</div>
          </div>
        )}
        {content.state && (
          <div className={styles.row}>
            <div className={styles.headingCell}>
              {intl.formatMessage(messages.state_label)}
            </div>
            <div className={styles.cell}>{content.state}</div>
          </div>
        )}
        {content.zipcode && (
          <div className={styles.row}>
            <div className={styles.headingCell}>
              {intl.formatMessage(messages.zipcode_label)}
            </div>
            <div className={styles.cell}>{content.zipcode}</div>
          </div>
        )}
        {content.mobile && (
          <div className={styles.row}>
            <div className={styles.headingCell}>
              {intl.formatMessage(messages.mobile_label)}
            </div>
            <div className={styles.cell}>{content.mobile}</div>
          </div>
        )}
        {content.phone && (
          <div className={styles.row}>
            <div className={styles.headingCell}>
              {intl.formatMessage(messages.phone_label)}
            </div>
            <div className={styles.cell}>{content.phone}</div>
          </div>
        )}
        {content.fax && (
          <div className={styles.row}>
            <div className={styles.headingCell}>
              {intl.formatMessage(messages.fax_label)}
            </div>
            <div className={styles.cell}>{content.fax}</div>
          </div>
        )}
        {content.email && (
          <div className={styles.row}>
            <div className={styles.headingCell}>
              {intl.formatMessage(messages.email_label)}
            </div>
            <div className={styles.cell}>
              <a href={`mailto:${content.email}`}>{content.email}</a>
            </div>
          </div>
        )}
        {content.www && (
          <div className={styles.row}>
            <div className={styles.headingCell}>
              {intl.formatMessage(messages.website_label)}
            </div>
            <div className={styles.cell}>
              <UniversalLink href={content.www} openLinkInNewTab={true}>
                {content.www}
              </UniversalLink>
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export default ContactView;

const messages = defineMessages({
  address_label: {
    id: 'address_label',
    defaultMessage: 'Address',
  },
  city_label: {
    id: 'city_label',
    defaultMessage: 'City',
  },
  state_label: {
    id: 'state_label',
    defaultMessage: 'State',
  },
  zipcode_label: {
    id: 'zipcode_label',
    defaultMessage: 'Zip code',
  },
  mobile_label: {
    id: 'mobile_label',
    defaultMessage: 'Mobile',
  },
  phone_label: {
    id: 'phone_label',
    defaultMessage: 'Phone',
  },
  fax_label: {
    id: 'fax_label',
    defaultMessage: 'Fax',
  },
  email_label: {
    id: 'email_label',
    defaultMessage: 'Email',
  },
  website_label: {
    id: 'website_label',
    defaultMessage: 'Website',
  },
  notes_label: {
    id: 'notes_label',
    defaultMessage: 'Notes',
  },
});
